@if (message) {
    <ng-container>
        <div class="offers-home-page message-panel">
            <div [ngClass]="isRgStatus ? 'theme-error-i' : 'theme-info-i'">
                <div class="cms-container" [vnDynamicHtml]="message"></div>
            </div>
        </div>
    </ng-container>
}
